import React, { useEffect, useState } from 'react'
import MotionHoc from '../../../utils/MotionHoc';
import { Card, Spin, message } from "antd";
import axios from "axios";
import dayjs from "dayjs";

import CalendarView from './CalendarView';
import DetailView from './DetailView';

import { baseUrlAREA, HEADERS_BASIC, LOAD_MAIN_LETTER } from '../../API/apiUrlsNew';

function MainLetterCalendar() {
  const [loading, setLoading] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [activeCalendarTab, setActiveCalendarTab] = useState("post");
  const [isDetailView, setIsDetailView] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDayList, setSelectedDayList] = useState([]);
  const [calendarValue, setCalendarValue] = useState(dayjs());
  const [calendarMode, setCalendarMode] = useState("month");
  const COMPANY_ID = localStorage.getItem("COMPANY_ID");

  useEffect(() => {
    loadData(dayjs());
  }, []);

  const loadData = (e) => {
    setLoading(true);
    axios.post(baseUrlAREA + LOAD_MAIN_LETTER, { date: e, company: COMPANY_ID }, { headers: HEADERS_BASIC })
      .then((response) => {
        if (response.status === 200) {
          setMasterData(response.data.data);
        }
      })
      .catch((error) => {
        const status = error?.response?.status;
        const serverMsg = error?.response?.data?.message;
        console.error("API error:", status, serverMsg || error.message);
        setMasterData([]);
        message.error(serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSelectDate = (date, dayList) => {
    setSelectedDate(date);
    setSelectedDayList(dayList);
    setIsDetailView(true);
  };

  const handleBackToCalendar = () => {
    setIsDetailView(false);
    setSelectedDate(null);
    setSelectedDayList([]);
  };

  return (
    <Spin spinning={loading} size="large" tip=" Loading... ">
      <Card>
        {!isDetailView ? (
          <CalendarView
            masterData={masterData}
            activeCalendarTab={activeCalendarTab}
            onTabChange={setActiveCalendarTab}
            onSelectDate={handleSelectDate}
            onReload={loadData}
            calendarValue={calendarValue}
            calendarMode={calendarMode}
            onCalendarChange={(v, m) => { setCalendarValue(v); if (m) setCalendarMode(m); }}
          />
        ) : (
          <DetailView
            key={selectedDate?.toString()}
            initialData={selectedDayList}
            selectedDate={selectedDate}
            activeCalendarTab={activeCalendarTab}
            onBack={handleBackToCalendar}
            onReload={loadData}
          />
        )}
      </Card>
    </Spin>
  );
}

const MainLetterCalendars = MotionHoc(MainLetterCalendar);
export default MainLetterCalendars;
